import { Contact } from '../pages/protected/contacts/Contact';
import { Finder } from '../pages/protected/finder/Finder';
import { ProjectActivities } from '../pages/protected/project-activities/ProjectActivities';
import { RecruitmentDashboard } from '../pages/protected/recruitment/RecruitmentDashboard';
import { ServiceActivities } from '../pages/protected/service-activities/ServiceActivities';
import { Application } from '../services/soap/features/responses/ListApplicationsResponse';
import { ComponentType } from 'react';
import { Product } from '../pages/protected/products/Product';
import { Calendar } from '../pages/protected/calendar/Calendar';
import { Task } from '../pages/protected/task/Task';
import { Invoice } from '../pages/protected/invoice/Invoice';
import { Communication } from '../pages/protected/communication/Communication';
import { MessageListComponent } from '../components/protected/layout-components/MessageList/MessageListComponent';
import CommunicationList from "../pages/protected/communication/component/CommunicationList";
import { MessagingComponent } from '../pages/protected/messaging-component/MessagingComponent';

export const routesMap: Map<string, ComponentType<any>> = new Map();

routesMap.set('com.atollon.recruitment.dashboard', RecruitmentDashboard);
routesMap.set('com.atollon.core.finder', Finder);
routesMap.set('com.atollon.core.contact', Contact);
routesMap.set('module-project=>serviceActivity', ServiceActivities);
routesMap.set('module-project=>sales', ProjectActivities);
routesMap.set('com.atollon.item.product', Product);
routesMap.set('com.atollon.scheduler.events', Calendar);
routesMap.set('com.atollon.scheduler.task', Task);
routesMap.set('com.atollon.messaging.message', CommunicationList);
routesMap.set('com.atollon.invoice.offer-issued', Invoice);
routesMap.set('com.atollon.invoice.order-received', Invoice);
routesMap.set('com.atollon.invoice.invoice-issued', Invoice);
routesMap.set('com.atollon.invoice.offer-received', Invoice);
routesMap.set('com.atollon.invoice.order-issued', Invoice);
routesMap.set('com.atollon.invoice.invoice-received', Invoice);

export function getPrimaryPath(app: Application): string {
  switch (app.accessType.toLowerCase()) {
    case 'system':
      var system_app = routesMap.get(app.appIdent);
      if (system_app && app.primaryPath) return app.primaryPath;
      break;
    case 'custom':
      var data = JSON.parse(app.data);
      if (data.handler) {
        var custom_app = routesMap.get(data.handler);
        if (custom_app && app.primaryPath) return app.primaryPath;
      }
      break;
    default:
      break;
  }

  return '/user/NotFound?service=' + app.appIdent;
}
